module.exports = __webpack_public_path__ + "img/PK.63575628.svg";